import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  CardContent,
  LinearProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../component-lib/Molecules/button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: "16px 24px" },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
  "& .MuiPaper-root": {
    borderRadius: "8px",
    height: "auto",
    width: "850px",
    maxWidth: "none",
  },
}));

interface ImportedDataSummeryDialogProps {
  isOpen: boolean;
  dialogHeading?: string;
  handleClose: () => void;
  summeryData: any;
}

const ImportedDataSummeryDialog = ({
  isOpen,
  summeryData,
  handleClose,
  dialogHeading,
}: ImportedDataSummeryDialogProps) => {
  const total =
    summeryData?.failed?.length +
    summeryData?.success?.validDSM?.length +
    summeryData?.success?.valideICD10Code?.length;
  const successPercentage =
    ((summeryData?.success?.validDSM?.length +
      summeryData?.success?.valideICD10Code?.length) /
      total) *
    100;
  const successCount =
    summeryData?.success?.validDSM?.length +
    summeryData?.success?.valideICD10Code?.length;
  const failCount = summeryData?.failed?.length;
  const failPercentage = (summeryData?.failed?.length / total) * 100;

  const headerStyle = {
    fontWeight: "600",
    fontSize: "18px",
    paddingBottom: "10px",
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading ?? ""} customStyle={headerStyle} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          <CardContent>
            <p className="text-green-600 font-semibold">
              Success: {successCount}
            </p>
            <p className="text-red-600 font-semibold">Failed: {failCount}</p>
            <div className="my-4">
              <LinearProgress
                variant="determinate"
                value={successPercentage}
                className="h-2 rounded-md bg-gray-200"
              />
            </div>
            {failCount > 0 && (
              <div className="mt-4">
                <h3 className="text-lg font-semibold text-red-500">
                  Failed Records
                </h3>
                <table className="w-full border-collapse border border-gray-300 mt-2">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border p-2">Code</th>
                      <th className="border p-2">Error</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summeryData?.failed?.map((record: any, index: number) => (
                      <tr key={index} className="border">
                        <td className="border p-2">{record?.Code}</td>
                        <td className="border p-2 text-red-500">
                          {record.error}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardContent>
        </DialogContent>

        <DialogActions>
          <div className="p-2">
            <Button
              label={TEXT_CONSTANTS?.CLOSE}
              variant="contained"
              onClickCb={handleClose}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginRight: "6px",
              }}
            />
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default ImportedDataSummeryDialog;
